// extracted by mini-css-extract-plugin
export default {"multiSelectContainer":"FormMultiSelect_multiSelectContainer__dqODZ"};